export default "__VITE_ASSET__CWI1HKBf__"